import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetConsolidationRuleSetMutationVariables = Types.Exact<{
  input: Types.SetConsolidationRuleSetInput;
}>;


export type SetConsolidationRuleSetMutation = { __typename?: 'Mutation', setConsolidationRuleSet: { __typename?: 'ConsolidationRuleSetPayload', consolidationRuleSet?: { __typename?: 'ConsolidationRuleSetStateData', tenantId: string, minimumLotQuantity: number, lookBackWeeks: number, lookForwardWeeks: number, direction: Types.ConsolidationDirection, roundingUnit?: number | null, customerGrouping: Types.ConsolidationCustomerGrouping, locationGrouping: Types.ConsolidationLocationGrouping } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ApplyConsolidationMutationVariables = Types.Exact<{
  input: Types.ApplyConsolidationInput;
}>;


export type ApplyConsolidationMutation = { __typename?: 'Mutation', applyConsolidation: { __typename?: 'ApplyConsolidationPayload', success: boolean, consolidationResults: Array<{ __typename?: 'ApplyConsolidationResultData', newProductionLotId?: string | null, archivedProductionLotIds: Array<string>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConsolidationRuleSetStateFieldsFragment = { __typename?: 'ConsolidationRuleSetStateData', tenantId: string, minimumLotQuantity: number, lookBackWeeks: number, lookForwardWeeks: number, direction: Types.ConsolidationDirection, roundingUnit?: number | null, customerGrouping: Types.ConsolidationCustomerGrouping, locationGrouping: Types.ConsolidationLocationGrouping };

export type ApplyConsolidationResultFieldsFragment = { __typename?: 'ApplyConsolidationResultData', newProductionLotId?: string | null, archivedProductionLotIds: Array<string>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null };

export const ConsolidationRuleSetStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationRuleSetStateFields on ConsolidationRuleSetStateData {
  tenantId
  minimumLotQuantity
  lookBackWeeks
  lookForwardWeeks
  direction
  roundingUnit
  customerGrouping
  locationGrouping
}
    `, {"fragmentName":"ConsolidationRuleSetStateFields"});
export const ApplyConsolidationResultFieldsFragmentDoc = new TypedDocumentString(`
    fragment ApplyConsolidationResultFields on ApplyConsolidationResultData {
  newProductionLotId
  archivedProductionLotIds
  errors {
    code
    message
  }
}
    `, {"fragmentName":"ApplyConsolidationResultFields"});
export const SetConsolidationRuleSetDocument = new TypedDocumentString(`
    mutation SetConsolidationRuleSet($input: SetConsolidationRuleSetInput!) {
  setConsolidationRuleSet(input: $input) {
    consolidationRuleSet {
      ...ConsolidationRuleSetStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ConsolidationRuleSetStateFields on ConsolidationRuleSetStateData {
  tenantId
  minimumLotQuantity
  lookBackWeeks
  lookForwardWeeks
  direction
  roundingUnit
  customerGrouping
  locationGrouping
}`);
export const ApplyConsolidationDocument = new TypedDocumentString(`
    mutation ApplyConsolidation($input: ApplyConsolidationInput!) {
  applyConsolidation(input: $input) {
    success
    consolidationResults {
      ...ApplyConsolidationResultFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ApplyConsolidationResultFields on ApplyConsolidationResultData {
  newProductionLotId
  archivedProductionLotIds
  errors {
    code
    message
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetConsolidationRuleSet: build.mutation<SetConsolidationRuleSetMutation, SetConsolidationRuleSetMutationVariables>({
      query: (variables) => ({ document: SetConsolidationRuleSetDocument, variables })
    }),
    ApplyConsolidation: build.mutation<ApplyConsolidationMutation, ApplyConsolidationMutationVariables>({
      query: (variables) => ({ document: ApplyConsolidationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetConsolidationRuleSetMutation, useApplyConsolidationMutation } = injectedRtkApi;
